import React from 'react';
import clsx from 'classnames';
import './index.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const Honor = () => {
  const breakpoints = {
    // 小屏幕（手机）
    640: {
      slidesPerView: 1,
      spaceBetween: 0,
    },
    // 中等屏幕（平板）
    768: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
    // 大屏幕（桌面）
    1024: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    1200: {
      slidesPerView: 2,
      spaceBetween: 0,
    },
    1530: {
      slidesPerView: 3,
      spaceBetween: 5,
    },
  };

  const certificateList = [
    '/img/certificateOne.png',
    '/img/certificateTwo.png',
    '/img/certificateThree.png',
  ];

  return (
    <div className={clsx('blurb-honor')}>
      <div className={clsx('blurb-honor-title')}>荣誉资质</div>
      <div className={clsx('blurb-honor-list')}>
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          navigation
          autoplay={true}
          loop={false}
          // 关闭底部点设置
          pagination={false}
          breakpoints={breakpoints}
          className={clsx('blurb-honor-swiper')}
        >
          {certificateList.map((v, index) => (
            <SwiperSlide key={index}>
              <div className={clsx('blurb-honor-swiper-item')}>
                <img src={v} alt='' width={'80%'} />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <div className={clsx('blurb-honor-certificates')}>
        <img src='/img/certificates.png' alt='' width={'100%'} />
      </div>
    </div>
  );
};

export default Honor;
